module.exports = __webpack_public_path__ + "img/Cancel-icon.46c214b3.svg";